import { useState } from 'react';
import { useAuthContext } from './useAuthContext';
import { axiosInstance } from '../context/AuthContext';

const toAuthPayload = (data) => ({
  ...data.user,
  token: data.token,
});

export const useSignup = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { dispatch } = useAuthContext();

    const signup = async (firstName, lastName, email, password, galleryId) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await axiosInstance.post('/auth/signup', {
                firstName,
                lastName,
                email,
                password,
                galleryId,
            });

            const json = toAuthPayload(response.data);
            localStorage.setItem('user', JSON.stringify(json));
            dispatch({ type: 'LOGIN', payload: json });
            setIsLoading(false);
            return json;
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'Signup failed. Please try again.';
            setError(errorMessage);
            setIsLoading(false);
            return null;
        }
    };

    return { signup, isLoading, error };
};
